import { Dispatch, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';
import AttendeeBox from './AttendeeBox';
import { ITravelRequestPerson } from 'entities/Flights/sdk';
import AgreementCheckbox from 'pages/FlightOffer/AgreementCheckbox';
import { H2 } from 'components/ui/typography.tsx';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from 'components/ui/accordion.tsx';

const AttendeesSection = ({
  people,
  hasAlreadyAgreed,
  isPersonalInfoAgreed,
  setPersonalInfoAgreed,
}: {
  people: ITravelRequestPerson[];
  hasAlreadyAgreed: boolean;
  isPersonalInfoAgreed: boolean;
  setPersonalInfoAgreed: Dispatch<SetStateAction<boolean>>;
}) => {
  const { t } = useTranslation();

  return (
    <div className='flex flex-col max-lg:gap-[16px]'>
      <div className='flex justify-between max-lg:flex-col max-lg:items-center max-lg:gap-[16px]'>
        <H2>{t('flightOffer.attendees')}</H2>
        <AgreementCheckbox
          label={t('flightOffer.agreePersonalInfo')}
          checked={isPersonalInfoAgreed || hasAlreadyAgreed}
          onChange={setPersonalInfoAgreed}
          disabled={hasAlreadyAgreed}
        />
      </div>
      <Accordion>
        <AccordionItem>
          <AccordionTrigger className='flex gap-[6px] justify-center items-center'>
            <div className='w-[24px] h-[24px] rounded-[50%] bg-content-primary text-white flex items-center justify-center'>
              {people.length}
            </div>
            <div className='font-[MuseoSansCyrl] text-content-secondary text-base'>
              {t('flightOffer.showAllAttendees')}
            </div>
          </AccordionTrigger>
          <AccordionContent className='p-4 flex gap-[24px] flex-wrap shadow-md rounded-xl'>
            {people.map((person) => (
              <AttendeeBox person={person} />
            ))}
          </AccordionContent>
        </AccordionItem>
      </Accordion>
    </div>
  );
};

export default AttendeesSection;
